var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('c-button',{attrs:{"color":"secondary","size":"lg"}},[_c('a',{attrs:{"href":_vm.docValue,"target":"_blank"}},[_vm._v(" View ")])]),_c('iframe',{staticStyle:{"border":"none"},attrs:{"className":"doc","src":_vm.docValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }